/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../../api/types.generated";
export type GetSponsorsQueryVariables = Types.Exact<{
  event_slug: Types.Scalars["String"];
}>;

export type GetSponsorsQuery = {
  sponsorCompaniesByEvent: Array<
    Pick<Types.SponsorCompany, "id" | "slug" | "tier">
  >;
};

export const GetSponsorsDocument = gql`
  query getSponsors($event_slug: String!) {
    sponsorCompaniesByEvent(event_slug: $event_slug) {
      id
      slug
      tier
    }
  }
`;

/**
 * __useGetSponsorsQuery__
 *
 * To run a query within a React component, call `useGetSponsorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSponsorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSponsorsQuery({
 *   variables: {
 *      event_slug: // value for 'event_slug'
 *   },
 * });
 */
export function useGetSponsorsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSponsorsQuery,
    GetSponsorsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<GetSponsorsQuery, GetSponsorsQueryVariables>(
    GetSponsorsDocument,
    baseOptions
  );
}
export function useGetSponsorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSponsorsQuery,
    GetSponsorsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetSponsorsQuery,
    GetSponsorsQueryVariables
  >(GetSponsorsDocument, baseOptions);
}
export type GetSponsorsQueryHookResult = ReturnType<typeof useGetSponsorsQuery>;
export type GetSponsorsLazyQueryHookResult = ReturnType<
  typeof useGetSponsorsLazyQuery
>;
export type GetSponsorsQueryResult = ApolloReactCommon.QueryResult<
  GetSponsorsQuery,
  GetSponsorsQueryVariables
>;
